module.exports = __webpack_public_path__ + "static/media/analyze.61046fab.png";